import request from "./index";

export const Customer = {
  GetCountryAllSkill: (data) => {
    return request.post("/api/Customer/GetCountryAllSkill", data);
  },
  GetLinkPreview: (data) => {
    return request.post("/api/Customer/GetLinkPreview", data);
  },
  DownloadUploadFile: (data, config) => {
    return request.post("/api/Customer/DownloadUploadFile", data, config);
  },
  CheckIsCrossSite: (data) => {
    return request.post("/api/Customer/CheckIsCrossSite", data);
  },
  // 取得對話紀錄
  GetClientChatDetail: (data) => {
    return request.post("/api/Customer/History/GetClientChatDetail", data);
  },
  GetMessageList: (data) => {
    return request.post("/api/ChatBot/ChatBotMessage/GetMessageList", data);
  },
};
